module.exports = __webpack_public_path__ + "media/assets/icons/quill/underline-114a6325cfa304f3b1d395ceadd69bc4.svg";